module.exports = __webpack_public_path__ + "img/Newbie_Staff_03_Classic.725a8b5a.png";